import { useContext } from 'react'
import { MentorProfileContext } from 'src/mentor/context/MentorProfileContext'
import MentorHeader from '../MentorHeader'
import { LegalPoliciesListingComponent } from './components/LegalPoliciesListingComponent'

export default function LegalPoliciesListingPage({
  header = true,
  tabs = true,
  customOnClick,
  showOnlyNotAccepted = false,
  mentorProfileData,
}) {
  const { allLegalPolicies, mentorProfileData: mentorProfileContextData } =
    useContext(MentorProfileContext)

  return (
    <>
      <LegalPoliciesListingComponent
        customOnClick={customOnClick}
        tabs={tabs}
        header={header ? <MentorHeader heading="Agreements, Tax and Banking" /> : false}
        showOnlyNotAccepted={showOnlyNotAccepted}
        allLegalPolicies={allLegalPolicies}
        mentorProfileData={mentorProfileData || mentorProfileContextData}
      />
    </>
  )
}
